import React from 'react';
import { twMerge } from 'tailwind-merge';
import { cn } from '@/lib/utils';

interface StatCardProps {
  text: string;
  variant?: 'success' | 'warning' | 'danger' | 'info';
  className?: string;
}

const variantColorMap = {
  info: 'text-blue-600',
  success: 'text-green-600',
  warning: 'text-yellow-600',
  danger: 'text-red-600',
};

const StatCard = (props: StatCardProps) => {
  const { text, variant = 'info', className } = props;

  const mainColorClass = variantColorMap[variant];

  return (
    <div className={cn('gap-2 py-1 sm:flex-col sm:gap-0 sm:p-4', className)}>
      <div
        className={twMerge(
          'text-center text-sm font-bold uppercase sm:text-base',
          mainColorClass,
        )}
      >
        {text}
      </div>
    </div>
  );
};

export default StatCard;
